// extracted by mini-css-extract-plugin
export default {"root":"PcClientTabs_root__AKJ0B","tabs":"PcClientTabs_tabs__5nBNL"};